// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3dYdF","header":"ReportDetails_header__1JzOQ","title":"ReportDetails_title__3xuKz","left":"ReportDetails_left__2hFGh"};